// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

.checkbox-wrapper {
  height: 30px;
}

.blue-sided-div {
  border-left: 3px solid #03a9f4;
  padding-left: 1.5em !important;
  margin-top: 1em;
  margin-bottom: 1em;
}

.filter-caption {
  background-color: #ececec;
  border-radius: 20px !important;
  padding: 0px 10px 0px 10px !important;
  margin: 1em 0px 0.2em 1em !important;
  display: inline-block !important;
}

@media screen and (max-width: 596px) and (min-width: 100px) {
  .blue-sided-div {
    border-left: 0px solid #03a9f4;
    padding-left: 0em !important;
    margin-top: 0em;
    margin-bottom: 0em;
  }
  .filter-caption {
    margin: 0.1em 0px 0.1em 0.1em !important;
  }
  .mat-expansion-panel-header {
    padding: 0 15px;
  }
}
@media screen and (max-width: 959px) and (min-width: 100px) {
  .column-mobile-margin {
    margin-top: 3em;
  }
}
.my-tasks-only {
  margin-top: 1.3em;
}

/* mat-expansion-panel-filter */
.mat-expansion-panel-header-title, .mat-expansion-panel-header-description {
  display: inline;
}

.mat-expansion-panel-header {
  height: initial;
  min-height: 56px;
  padding-bottom: 0.5em;
}

.mat-expansion-panel-header.mat-expanded {
  height: initial;
  min-height: 56px;
}

.mat-expansion-panel:not(.mat-expanded):not([aria-disabled=true]) .mat-expansion-panel-header:hover {
  background: #fff;
  height: initial;
  min-height: 56px;
}

.mat-expansion-panel-header.mat-expanded {
  background-color: #f5f5f5 !important;
}

@media screen and (max-width: 840px) {
  .hw-container-background {
    margin: -60px 0px 0px 0px;
    padding: 1em;
  }
}
.mat-mdc-table .mat-mdc-header-cell {
  z-index: 0 !important;
}

.mat-mdc-optgroup-label .mdc-list-item__primary-text {
  font-weight: 800 !important;
}

.group-selection {
  font-family: "Roboto" !important;
  font-size: 16px !important;
  font-weight: 600;
}

.hw-sum-grid-cell {
  font-weight: 600;
  font-size: 13px;
}

.footer {
  background-color: #c6c6c6 !important;
}

.filter-caption {
  background-color: #ececec;
  border-radius: 20px !important;
  padding: 10px;
  margin-right: 10px;
  display: inline-block !important;
  font-weight: 500;
  font-size: 12px;
}

#table-container {
  height: 400px;
  overflow: auto;
  width: 100%;
  margin-top: 1em;
}

table {
  width: 100%;
}

.panel-header {
  height: 400px;
  width: 100%;
}

.boolean-cell {
  font-size: 25px;
  color: #2196f3;
}

@media (max-width: 599px) {
  .hw-grid-cell {
    float: right;
    text-align: right;
    font-weight: bold;
    font-size: 14px;
    padding: 5px 5px 5px 5px;
  }
  .boolean-cell {
    font-size: 20px;
  }
  .action-buttons {
    padding-bottom: 1em;
    margin-right: 1em;
  }
  th.mat-header-cell,
  td.mat-cell,
  td.mat-footer-cell {
    margin-bottom: 1em;
  }
  tr.mat-row,
  tr.mat-footer-row {
    height: 48px;
    width: 100%;
  }
  .hw-mobile-table-title-show {
    text-align: left;
  }
  .hw-mobile-width-50 {
    width: inherit;
  }
  .mdc-data-table__cell, .mdc-data-table__header-cell {
    padding: 0px;
  }
  .hw-mobile-display-inherit {
    display: flex;
  }
  .hw-mobile-table-title-show {
    display: inline-block;
    padding: 5px 5px 5px 5px;
  }
  .mat-mdc-footer-row {
    display: none;
  }
}
.float-button {
  margin-bottom: -1em;
  margin-right: 0em;
}

.hw-checkbox-vertical-align {
  margin-top: 20px;
}

.hw-horizontal-divider {
  display: flex;
  background: #03a9f4;
  height: 2px;
}

#table-container .zebra-row:nth-child(even) {
  background-color: #f2f2f2;
}

#table-container .zebra-row:nth-child(odd) {
  background-color: white;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
